/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Http_ForbiddenInputs */

const de_commons_error_page_http_forbidden = /** @type {(inputs: Commons_Error_Page_Http_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff nicht erlaubt`)
};

/** @type {(inputs: Commons_Error_Page_Http_ForbiddenInputs) => LocalizedString} */
const en_commons_error_page_http_forbidden = de_commons_error_page_http_forbidden;

/**

* @param {Commons_Error_Page_Http_ForbiddenInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_http_forbidden = /** @type {((inputs?: Commons_Error_Page_Http_ForbiddenInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Http_ForbiddenInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_http_forbidden(inputs)
	return en_commons_error_page_http_forbidden(inputs)
});